import { GetAllWarehousesPayload } from "../../services/warehouses/get-all/types";
import { OrderStart } from "../../types/order-form";

interface GetOrderStart {
  type: "GET_ORDER_START_SUCCESS";
  payload: OrderStart;
}

type Action = GetOrderStart;

export type OrderState = {
  orderStart: OrderStart | null;
};

const initialState: OrderState = {
  orderStart: null,
};

export const OrderReducer = (
  state: OrderState = initialState,
  action: Action
) => {
  switch (action.type) {
    case "GET_ORDER_START_SUCCESS": {
      return {
        orderStart: action.payload,
      };
    }

    default:
      return state;
  }
};
